import { SelectOption } from 'components/Selects/Select/StepsDropdown/types';
import { PermitStatus } from 'mittweida/inquiry/fields';
import { translations } from 'new/form/common/types';
import { FormatMessage } from 'utils/intl';

const {
  criticalWithRestRisk,
  uncriticalNoPermitYet,
  preliminaryInquiryExists,
  permitExists,
  permitUnnecessary,
} =
  translations.inquiryType.mittweida.pages.financingNeed.sections.otherProjectInformation.fields
    .permitStatus.options;

export const permitStatusOptions: SelectOption<PermitStatus>[] = [
  {
    label: criticalWithRestRisk,
    value: 'critical_with_rest_risk',
  },
  {
    label: uncriticalNoPermitYet,
    value: 'uncritical_no_permit_yet',
  },
  {
    label: preliminaryInquiryExists,
    value: 'preliminary_inquiry_exists',
  },
  {
    label: permitExists,
    value: 'permit_exists',
  },
  {
    label: permitUnnecessary,
    value: 'permit_unnecessary',
  },
];

export const getMittweidaPermitStatusOptions = (
  formatMessage: FormatMessage,
): SelectOption<PermitStatus>[] => {
  return permitStatusOptions.map(({ label, value }) => {
    return {
      value,
      label: formatMessage({ id: label }),
    };
  });
};
